import React from "react";
import EntryWrap from "../../components/entryComponents/EntryWrap";
import SignUpContent from "../../components/entryComponents/SignUp";

const SignUp = ({ setLoader }) => {
  return (
    <EntryWrap>
      <SignUpContent setLoader={setLoader} />
    </EntryWrap>
  );
};

export default SignUp;
